@for (item of previewUrls(); track item ) {

<div class="relative flex" (click)="onItemClicked(item)" aria-hidden="true"
  [ngClass]="{'cursor-pointer': this.isSuggestions() && !isSuggestionSelected(item)}">
  <div
    class="bg-white rounded-full shadow-xl w-7 h-7 absolute top-0 right-[-10px] cursor-pointer text-yellow flex items-center justify-center"
    aria-hidden="true" (click)="onIconClicked(item, $index, $event)">
    <app-icon name="heroXMark" size="medium"></app-icon>
  </div>
  <app-image-preview class="w-28 h-28 mt-4 rounded-xl" [url]="item.url"></app-image-preview>
</div>

}
<!--isSuggestionSelected(item) ? 'heroXMark' : 'circle-blue'"-->
